import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import CaseTypesPage from "./pages/CaseTypesPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import ResultsPage from "./pages/ResultsPage";
import ContactPage from "./pages/ContactPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/case-types" element={<CaseTypesPage />} />
          <Route path="/case-types/:id" element={<CaseTypesPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/results" element={<ResultsPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
